<div
  class="sidebar"
  [class.has-expander]="hasExpander"
  [class.large]="size === 'large'"
  [@collapseHorizontal]="collapseState"
  (@collapseHorizontal.start)="animationEvent.emit($event)"
  (@collapseHorizontal.done)="animationEvent.emit($event)"
>
  <ng-content></ng-content>
</div>
<div *ngIf="hasExpander" class="expander" [class.collapsed]="isMinimized">
  <rt-button variant="only-icon" (click)="onExpanderClick()">
    <rt-icon [name]="isMinimized ? 'chevron-right' : 'chevron-left'" size="medium"></rt-icon>
  </rt-button>
</div>
